import { useRef, useState } from 'react';
import useDialogFocus from '../../hooks/useDialogFocus';
import { fmtCents } from './helpers';

export const ACTIONS = {
  approve: { title: 'Approve', button: 'btn-success', icon: 'bi-check-circle', noteRequired: false },
  reject: { title: 'Reject', button: 'btn-danger', icon: 'bi-x-circle', noteRequired: true },
  mark_paid: { title: 'Mark paid', button: 'btn-primary', icon: 'bi-cash-coin', noteRequired: false },
  note: { title: 'Add note', button: 'btn-secondary', icon: 'bi-chat-left-text', noteRequired: true },
};

/**
 * Confirm an approver action on `count` expenses totalling `cents`, with a note
 * (required to reject or to add a note). `onConfirm(note)` does the work.
 */
const ReviewActionModal = ({ action, count, cents, description, onConfirm, onClose, busy, error }) => {
  const dialogRef = useRef(null);
  useDialogFocus(dialogRef);
  const [note, setNote] = useState('');
  const meta = ACTIONS[action];
  const noteMissing = meta.noteRequired && !note.trim();

  const handleSubmit = (e) => {
    e.preventDefault();
    if (!noteMissing) onConfirm(note);
  };

  return (
    <div
      ref={dialogRef}
      className="modal show d-block"
      tabIndex="-1"
      role="dialog"
      aria-modal="true"
      aria-labelledby="reviewActionTitle"
      style={{ backgroundColor: 'rgba(0,0,0,0.5)' }}
    >
      <div className="modal-dialog">
        <div className="modal-content">
          <div className="modal-header">
            <h5 className="modal-title" id="reviewActionTitle">
              <i className={`bi ${meta.icon} me-2`}></i>
              {meta.title}
            </h5>
            <button type="button" className="btn-close" onClick={onClose} disabled={busy} aria-label="Close"></button>
          </div>
          <form onSubmit={handleSubmit}>
            <div className="modal-body">
              <p>
                {description || (
                  <>
                    {meta.title} <strong>{count}</strong> {count === 1 ? 'expense' : 'expenses'} totalling{' '}
                    <strong>{fmtCents(cents)}</strong>.
                  </>
                )}
              </p>
              <label htmlFor="reviewNote" className="form-label">
                Note {meta.noteRequired ? '*' : '(optional)'}
              </label>
              <textarea
                id="reviewNote"
                className="form-control"
                rows="3"
                maxLength={1000}
                value={note}
                onChange={(e) => setNote(e.target.value)}
                placeholder={action === 'reject' ? 'Why it was rejected, so the employee knows what to do' : 'Visible to the employee'}
                disabled={busy}
              />
              <div className="form-text">The employee sees this note on their expense.</div>
              {error && (
                <div className="alert alert-danger mt-3 mb-0" role="alert">
                  {error}
                </div>
              )}
            </div>
            <div className="modal-footer">
              <button type="button" className="btn btn-secondary" onClick={onClose} disabled={busy}>
                Cancel
              </button>
              <button type="submit" className={`btn ${meta.button}`} disabled={busy || noteMissing}>
                {busy ? 'Working…' : meta.title}
              </button>
            </div>
          </form>
        </div>
      </div>
    </div>
  );
};

export default ReviewActionModal;
